import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-lg font-bold text-foreground-900 hover:text-primary-600 transition-colors whitespace-nowrap">
              Sugargoo Spreadsheet
            </Link>
            <p className="text-xs text-foreground-500 mt-3 leading-relaxed max-w-xs">
              The most complete resource for discovering trending products, verified finds, and smart shopping guides — all in one organized database.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#categories" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Categories</a></li>
              <li><a href="#why-choose" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Why Choose</a></li>
              <li><a href="#review" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Review</a></li>
              <li><a href="#shipping" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Shipping Guide</a></li>
              <li><a href="#discount" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Discounts</a></li>
              <li><Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">Complete Guide</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">
              External Links
            </h4>
            <ul className="space-y-2.5">
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  Main Platform
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  Shoes Category
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-920/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                  Accessories
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-800 uppercase tracking-wider mb-4 whitespace-nowrap">
              Disclaimer
            </h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              This website is an independent educational resource. We are not Sugargoo and are not affiliated with Sugargoo officially. We provide product research information only. Users should always verify product information before purchasing.
            </p>
            <div className="flex items-center gap-4 mt-4">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/70">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-foreground-400 whitespace-nowrap">
            Built as an independent resource for the shopping community.
          </p>
        </div>
      </div>
    </footer>
  );
}